function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var Transaction = require('../../../lib/saito/transaction')["default"];
function messageOf(tx) {
  try {
    return typeof (tx === null || tx === void 0 ? void 0 : tx.returnMessage) === 'function' ? tx.returnMessage() : null;
  } catch (err) {
    return null;
  }
}
function createMigrationPayoutTransaction(_x, _x2, _x3) {
  return _createMigrationPayoutTransaction.apply(this, arguments);
}
function _createMigrationPayoutTransaction() {
  _createMigrationPayoutTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, row, amount) {
    var recipient, tx;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          recipient = row.recipient_publickey;
          _context.n = 1;
          return app.wallet.createUnsignedTransactionWithDefaultFee(recipient, app.wallet.convertSaitoToNolan(amount));
        case 1:
          tx = _context.v;
          tx.msg = {
            module: 'Mixin',
            request: 'migration issuance',
            amount: amount,
            hash: row.inbound_tx_hash || String(row.id),
            data: {
              id: row.id,
              requester_publickey: row.requester_publickey,
              recipient_publickey: row.recipient_publickey,
              inbound_ticker: row.inbound_ticker,
              inbound_amount: row.inbound_amount,
              outbound_amount: String(amount)
            }
          };
          _context.n = 2;
          return tx.sign();
        case 2:
          return _context.a(2, tx);
      }
    }, _callee);
  }));
  return _createMigrationPayoutTransaction.apply(this, arguments);
}
function receiveMigrationPayoutTransaction(tx, row) {
  if (!tx || !row || !tx.signature || tx.signature !== row.outbound_tx_sig) {
    return false;
  }
  var message = messageOf(tx);
  if (!message) {
    return true;
  }
  return message.module === 'Mixin' && message.request === 'migration issuance';
}

// inbound_tx_hash is the Mixin transaction hash recorded when the deposit was
// claimed. It identifies that external payment. inbound_tx_id is only the
// snapshot or deposit id from whichever observation was read, so it is not used.
// transfers.id is the persisted primary key of the credited row.
function storeIssuanceIdentifiers(row) {
  var inbound = typeof (row === null || row === void 0 ? void 0 : row.inbound_tx_hash) === 'string' ? row.inbound_tx_hash.trim() : '';
  var rawId = row === null || row === void 0 ? void 0 : row.id;
  var transferId = typeof rawId === 'number' ? rawId : typeof rawId === 'string' && /^[1-9]\d*$/.test(rawId) ? Number(rawId) : NaN;
  if (!inbound || !Number.isSafeInteger(transferId) || transferId <= 0) {
    return null;
  }
  return {
    inbound_payment_uuid: inbound,
    transfer_uuid: String(transferId)
  };
}
function createBuySaitoPayoutTransaction(_x4, _x5, _x6) {
  return _createBuySaitoPayoutTransaction.apply(this, arguments);
}
function _createBuySaitoPayoutTransaction() {
  _createBuySaitoPayoutTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, row, amountNolan) {
    var _preserved2, _preserved3;
    var recipient, preserved, _preserved, userTx, address, storePurchase, identifiers, tx;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          recipient = row.recipient_publickey;
          preserved = null;
          if (row.payload) {
            userTx = new Transaction();
            userTx.deserialize_from_web(app, row.payload);
            preserved = userTx.returnMessage();
            if ((_preserved = preserved) !== null && _preserved !== void 0 && _preserved.p2sh_address) {
              address = preserved.p2sh_address;
              recipient = address.length === 66 && address.startsWith('00') ? app.crypto.toBase58(address) : address;
            }
          }
          storePurchase = ((_preserved2 = preserved) === null || _preserved2 === void 0 ? void 0 : _preserved2.module) === 'Store' && ((_preserved3 = preserved) === null || _preserved3 === void 0 ? void 0 : _preserved3.request) === 'purchase-asset';
          identifiers = storePurchase ? storeIssuanceIdentifiers(row) : null;
          if (!(storePurchase && !identifiers)) {
            _context2.n = 1;
            break;
          }
          throw new Error('Store purchase is missing its inbound payment id or transfer id');
        case 1:
          _context2.n = 2;
          return app.wallet.createUnsignedTransactionWithDefaultFee(recipient, amountNolan);
        case 2:
          tx = _context2.v;
          if (storePurchase) {
            tx.msg = _objectSpread(_objectSpread({}, preserved), identifiers);
          } else if (preserved) {
            tx.msg = preserved;
          } else {
            tx.msg = {
              module: 'BuySaito',
              request: 'buysaito issuance',
              data: {
                id: row.id,
                requester_publickey: row.requester_publickey,
                recipient_publickey: row.recipient_publickey,
                inbound_ticker: row.inbound_ticker,
                inbound_amount: row.inbound_amount,
                outbound_amount: row.outbound_amount
              },
              memo: "".concat(row.inbound_amount, " ").concat(row.inbound_ticker)
            };
          }
          _context2.n = 3;
          return tx.sign();
        case 3:
          return _context2.a(2, {
            tx: tx,
            recipient: recipient
          });
      }
    }, _callee2);
  }));
  return _createBuySaitoPayoutTransaction.apply(this, arguments);
}
function receiveBuySaitoPayoutTransaction(tx, row) {
  if (!tx || !row || !tx.signature || tx.signature !== row.outbound_tx_sig) {
    return false;
  }
  var message = messageOf(tx);
  if (!message || row.payload) {
    return true;
  }
  return message.module === 'BuySaito' && message.request === 'buysaito issuance';
}
function createTreasuryPayoutRequestTransaction(_x7, _x8, _x9, _x0) {
  return _createTreasuryPayoutRequestTransaction.apply(this, arguments);
}
function _createTreasuryPayoutRequestTransaction() {
  _createTreasuryPayoutRequestTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, provider, row, requesterPublickey) {
    var tx, data;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return app.wallet.createUnsignedTransactionWithDefaultFee(provider);
        case 1:
          tx = _context3.v;
          data = {
            source_transfer_id: Number(row.id),
            purpose: row.purpose,
            outbound_amount: String(row.outbound_amount),
            recipient_publickey: row.recipient_publickey,
            requester_publickey: requesterPublickey
          };
          if (row.payload) {
            data.payload = row.payload;
          }
          if (row.inbound_tx_hash) {
            data.inbound_tx_hash = row.inbound_tx_hash;
          }
          if (row.inbound_ticker) {
            data.inbound_ticker = row.inbound_ticker;
          }
          if (row.inbound_amount) {
            data.inbound_amount = row.inbound_amount;
          }
          tx.msg = {
            module: 'Mixin',
            request: 'mixin-issue-treasury-payout',
            data: data
          };
          _context3.n = 2;
          return tx.sign();
        case 2:
          return _context3.a(2, tx);
      }
    }, _callee3);
  }));
  return _createTreasuryPayoutRequestTransaction.apply(this, arguments);
}
function restoreSavedSignedTransaction(app, serialized, expectedSignature) {
  var tx = new Transaction();
  tx.deserialize_from_web(app, serialized);
  if (!tx.signature || tx.signature !== expectedSignature) {
    return null;
  }
  return tx;
}
module.exports = {
  createMigrationPayoutTransaction: createMigrationPayoutTransaction,
  receiveMigrationPayoutTransaction: receiveMigrationPayoutTransaction,
  createBuySaitoPayoutTransaction: createBuySaitoPayoutTransaction,
  receiveBuySaitoPayoutTransaction: receiveBuySaitoPayoutTransaction,
  createTreasuryPayoutRequestTransaction: createTreasuryPayoutRequestTransaction,
  restoreSavedSignedTransaction: restoreSavedSignedTransaction,
  storeIssuanceIdentifiers: storeIssuanceIdentifiers
};